import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Stack,
  CircularProgress,
} from '@mui/material';
import { CloseIcon } from 'assets/icons';
import { absoluteCloseStyle } from 'pages/Forms/Theme/responseInputStyles';
import signatureImage from 'pages/Forms/RegisterForm/CustomFormBuilder/RenderFormField/style/signature.png';
import { formatDate } from 'utils/formatDate';

interface SignatureFieldProps {
  savedSignature?: string | null | undefined | Blob;
  removeSignature: (signatoryId?: string) => void;
  toggleSignaturePad: () => void;
  isLoading: boolean;
  created_at?: string | null;
}

const isFalsyValue = (value: string) => value === 'null';

const SignatureField: React.FC<SignatureFieldProps> = ({
  savedSignature,
  removeSignature,
  toggleSignaturePad,
  isLoading,
  created_at,
}) => {
  const formatedSignatureDate =
    created_at && !isFalsyValue(created_at)
      ? formatDate(created_at, 'date_with_time')
      : null;

  return (
    <>
      <Stack
        minHeight="200px"
        alignItems="center"
        justifyContent="center"
        border="1px dashed"
        borderColor="divider"
        position="relative"
      >
        {isLoading ? (
          <CircularProgress color="secondary" size={28} />
        ) : (
          <Box
            onClick={toggleSignaturePad}
            height="100%"
            role="button"
            aria-label={savedSignature ? 'Edit signature' : 'Add signature'}
          >
            {savedSignature ? (
              <Stack
                alignItems="flex-end"
                justifyContent="center"
                spacing={1}
                width="100%"
              >
                <IconButton
                  aria-label="Remove Signature"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSignature();
                  }}
                  sx={absoluteCloseStyle}
                >
                  <CloseIcon />
                </IconButton>
                <Box
                  component="img"
                  src={
                    savedSignature instanceof Blob
                      ? URL.createObjectURL(savedSignature)
                      : savedSignature || ''
                  }
                  alt="Saved Signature"
                />
              </Stack>
            ) : (
              <Stack
                alignItems="center"
                justifyContent="center"
                sx={{ cursor: 'pointer' }}
                spacing={1}
                height="100%"
              >
                <Box
                  component="img"
                  src={signatureImage}
                  alt="Signature"
                  height={60}
                />
                <Typography
                  variant="subtitle1"
                  color="action.active"
                  fontWeight="400"
                  textAlign="center"
                  lineHeight={1.5}
                >
                  Click here to add signature
                </Typography>
              </Stack>
            )}
          </Box>
        )}
      </Stack>
      {formatedSignatureDate && (
        <Typography variant="body2" color="textSecondary" mt={1}>
          <strong>Signature Date:</strong> {formatedSignatureDate}
        </Typography>
      )}
    </>
  );
};

export default SignatureField;
